










import Vue, { PropType } from 'vue';
import { CourseraCourse, CourseraCollection } from '~/models/coursera';
import CourseraCarousel from './CourseCarousel.vue';

export default Vue.extend({
    name: 'CourseraCollection',
    components: {
        CourseraCarousel,
    },
    props: {
        collection: {
            type: Object as PropType<CourseraCollection>,
            required: true,
        },
    },
    computed: {
        courses(): CourseraCourse[] {
            return this.collection.contents;
        },
    },
    methods: {
        emitOpenCourse(course: CourseraCourse) {
            this.$emit('open-course', course);
        },
    },
});
